/**
 * Loading schema
 *
 * @package lib-components
 * @copyright 2021-2025 Hexio a.s. <contact@hexio.io> (hexio.io) and contributors.
 * @license Apache-2.0
 *
 * See LICENSE file distributed with this source code for more information.
 */

import {
	BP,
	ISchemaConstBoolean,
	ISchemaConstObject,
	ISchemaConstObjectOptsProp,
	ISchemaOptionalGroup,
	ISchemaValue
} from "@adapptio/lib-blueprint";

import { termsEditor } from "../terms";

/**
 * Loading schema
 */
export function LoadingSchema(): ISchemaOptionalGroup<
	ISchemaValue<
		ISchemaConstObject<{
			renderContent: ISchemaConstObjectOptsProp<ISchemaValue<ISchemaConstBoolean>>;
		}>
	>
> {
	return BP.OptGroup({
		...termsEditor.schemas.common.loading,
		alias: "working",
		enabledOpts: {
			default: false,
			fallbackValue: false
		},
		value: BP.Object({
			props: {
				renderContent: BP.Prop(
					BP.Boolean({
						...termsEditor.schemas.common.loadingRenderContent,
						default: false,
						fallbackValue: false,
						constraints: {
							required: true
						}
					})
				)
			},
			editorOptions: {
				layoutType: "passthrough"
			}
		})
	});
}
